import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosCentral, throwResponse } from "config/axios";
import {
  IDashboardName,
  IDashboardParams,
  IDashboardUnitNumber,
  IResponseDashboardCentral,
} from "../../interface";
import { IDashboardFacilityType } from "./interface";

export const useGetDashboardFacility = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardName[]>[], Error> => {
  return useQuery(
    ["dashboard-facility", "most-facility", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/facility/most-facility", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardFacilityType = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardName[]>[], Error> => {
  return useQuery(
    ["dashboard-facility", "type", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/facility/most-facility", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardFacilityUnit = (
  params?: IDashboardParams
): UseQueryResult<
  IResponseDashboardCentral<IDashboardUnitNumber[]>[],
  Error
> => {
  return useQuery(
    ["dashboard-facility", "most-unit-used-facility", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/facility/most-unit-used-facility",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardFacilityMonth = (
  params?: IDashboardParams
): UseQueryResult<
  IResponseDashboardCentral<IDashboardFacilityType>[],
  Error
> => {
  return useQuery(
    ["dashboard-facility", "most-facility-month", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/facility/count-facility-booking-type",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
